"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SortableTableHeaderCell = void 0;
exports.getIcon = getIcon;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _index = require("../ButtonTertiary/index.js");
var _index2 = require("../Icon/icons/IconChartDown/index.js");
var _index3 = require("../Icon/icons/IconChartUp/index.js");
var _TableHeaderCell = require("./TableHeaderCell.js");
var _excluded = ["align", "scope", "sortedByDirection", "iconPlacement", "sortable", "onClick", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function getIcon(_ref) {
  var currentButtonIconProp = _ref.currentButtonIconProp,
    iconPlacement = _ref.iconPlacement,
    sortedByDirection = _ref.sortedByDirection;
  if (sortedByDirection === 'none') {
    return undefined;
  }
  if (iconPlacement === currentButtonIconProp) {
    return sortedByDirection === 'ascending' ? _index3.IconChartUp : _index2.IconChartDown;
  }
  return undefined;
}
var SortableTableHeaderCell = exports.SortableTableHeaderCell = function SortableTableHeaderCell(_ref2) {
  var align = _ref2.align,
    scope = _ref2.scope,
    sortedByDirection = _ref2.sortedByDirection,
    _ref2$iconPlacement = _ref2.iconPlacement,
    iconPlacement = _ref2$iconPlacement === void 0 ? 'trailing' : _ref2$iconPlacement,
    sortable = _ref2.sortable,
    onClick = _ref2.onClick,
    children = _ref2.children,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  var propsWithOrWithoutAriaSort = sortedByDirection !== 'none' ? _objectSpread({
    'aria-sort': sortedByDirection
  }, props) : _objectSpread({}, props);
  return /*#__PURE__*/_react["default"].createElement(_TableHeaderCell.TableHeaderCellElement, Object.assign({
    role: "columnheader",
    $active: sortedByDirection !== 'none',
    $align: align,
    scope: scope,
    $sortable: sortable
  }, propsWithOrWithoutAriaSort), /*#__PURE__*/_react["default"].createElement(_index.ButtonTertiary, {
    onClick: onClick,
    size: "small",
    semanticColor: "textBase",
    condensedAll: true,
    iconLeading: getIcon({
      currentButtonIconProp: 'leading',
      iconPlacement: iconPlacement,
      sortedByDirection: sortedByDirection
    }),
    iconTrailing: getIcon({
      currentButtonIconProp: 'trailing',
      iconPlacement: iconPlacement,
      sortedByDirection: sortedByDirection
    }),
    type: "button"
  }, children));
};